module.exports = __webpack_public_path__ + "static/model-keycap-t-1e3a9f9f6a08cf952b18a4c3abce6650.png";